module.exports = __webpack_public_path__ + "static/media/039-toothpaste.14bdb154.svg";